export default "__VITE_ASSET__78cfc450__"